import React, { useState } from 'react';
import axios from 'axios';
import { Eye, EyeOff } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [step, setStep] = useState(token ? 'reset' : 'forgot');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const sendReset = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Fehler beim Senden.');
    }
    setLoading(false);
  };

  const doReset = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError('Mindestens 8 Zeichen.');
    setLoading(true); setError('');
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Link ungültig oder abgelaufen.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
      <div className="w-full max-w-sm mx-4">
        <p className="text-[#befa0a] text-xs uppercase tracking-[0.3em] font-bold mb-2 text-center" style={{ fontFamily: "'Oswald', sans-serif" }}>
          ENBET Consulting
        </p>

        {done ? (
          <div className="text-center">
            <h2 className="text-white text-xl font-bold uppercase mb-4" style={{ fontFamily: "'Oswald', sans-serif" }}>
              {step === 'forgot' ? '✅ E-Mail gesendet' : '✅ Passwort gesetzt'}
            </h2>
            <p className="text-white/50 text-sm mb-6" style={{ fontFamily: "'Manrope', sans-serif" }}>
              {step === 'forgot'
                ? 'Prüfe dein Postfach — der Link ist 1 Stunde gültig.'
                : 'Du kannst dich jetzt einloggen.'}
            </p>
            <a href="/crm" className="bg-[#befa0a] text-[#0a0a0a] px-8 py-3 font-bold uppercase tracking-wider rounded hover:bg-lime-300 transition-colors inline-block"
              style={{ fontFamily: "'Oswald', sans-serif" }}>
              Zum Login
            </a>
          </div>
        ) : step === 'forgot' ? (
          <>
            <h1 className="text-white text-2xl font-bold uppercase tracking-tight text-center mb-2" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Passwort vergessen
            </h1>
            <p className="text-white/40 text-sm text-center mb-8" style={{ fontFamily: "'Manrope', sans-serif" }}>
              Wir schicken dir einen Reset-Link per E-Mail.
            </p>
            <form onSubmit={sendReset} className="space-y-4">
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="E-Mail" required
                className="w-full bg-white/5 border border-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-[#befa0a] placeholder-white/30 rounded"
                style={{ fontFamily: "'Manrope', sans-serif" }} />
              {error && <p className="text-red-400 text-sm">{error}</p>}
              <button type="submit" disabled={loading}
                className="w-full bg-[#befa0a] text-[#0a0a0a] py-3 font-bold uppercase tracking-wider rounded hover:bg-lime-300 transition-colors disabled:opacity-50"
                style={{ fontFamily: "'Oswald', sans-serif" }}>
                {loading ? 'Wird gesendet...' : 'Reset-Link senden'}
              </button>
              <a href="/crm" className="block text-center text-white/30 text-sm hover:text-white/60 transition-colors"
                style={{ fontFamily: "'Manrope', sans-serif" }}>
                Zurück zum Login
              </a>
            </form>
          </>
        ) : (
          <>
            <h1 className="text-white text-2xl font-bold uppercase tracking-tight text-center mb-8" style={{ fontFamily: "'Oswald', sans-serif" }}>
              Neues Passwort
            </h1>
            <form onSubmit={doReset} className="space-y-4">
              <div className="relative">
                <input type={showPw ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Neues Passwort (min. 8 Zeichen)" required
                  className="w-full bg-white/5 border border-white/10 text-white px-4 py-3 text-sm focus:outline-none focus:border-[#befa0a] placeholder-white/30 rounded pr-11"
                  style={{ fontFamily: "'Manrope', sans-serif" }} />
                <button type="button" onClick={() => setShowPw(s => !s)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-[#befa0a] transition-colors">
                  {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
              {error && <p className="text-red-400 text-sm">{error}</p>}
              <button type="submit" disabled={loading}
                className="w-full bg-[#befa0a] text-[#0a0a0a] py-3 font-bold uppercase tracking-wider rounded hover:bg-lime-300 transition-colors disabled:opacity-50"
                style={{ fontFamily: "'Oswald', sans-serif" }}>
                {loading ? 'Wird gespeichert...' : 'Passwort speichern'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
